export const PAYMENT_MODE = {
  CASH: "Cash",
  CASH_PLUS_POINTS: "Cash + Points",
  ONLY_POINTS: "Only Points",
};

export function derivePaymentMode(totalPayableAmount, burnPoints) {
  const onlyCash = totalPayableAmount > 0 && burnPoints === 0;
  const cashPlusPoints = totalPayableAmount > 0 && burnPoints > 0;
  return {
    onlyCash,
    cashPlusPoints,
    onlyPoints: !onlyCash && !cashPlusPoints,
    paymentMode: onlyCash
      ? PAYMENT_MODE.CASH
      : cashPlusPoints
        ? PAYMENT_MODE.CASH_PLUS_POINTS
        : PAYMENT_MODE.ONLY_POINTS,
  };
}

export function normalizePaymentMode(value) {
  const key = String(value || "")
    .toLowerCase()
    .replace(/[^a-z+]/g, "");
  if (key === "onlycash" || key === "cashonly") return "cash";
  if (key === "pointsonly") return "onlypoints";
  if (key === "cashandpoints" || key === "cashpoints") return "cash+points";
  return key;
}

export function isRedemptionFeeRequired(redemptionFeeApplied, paymentMode) {
  const modes = String(redemptionFeeApplied || "")
    .split(/[,|]/)
    .map(normalizePaymentMode)
    .filter(Boolean);
  return modes.includes(normalizePaymentMode(paymentMode));
}
